export const colorPalette = {
  primary: {
    lighter: '#51b4e1',
    light: '#2D96A3',
    main: '#215968',
    dark: '#102C33',
    darker: '#18414C',
    contrastText: '#ffffff',
  },
  secondary: {
    light: '#2D96A3',
    main: '#ffffff',
    dark: '#EEEEEE',
    contrastText: '#000000',
  },
  common: {
    white: '#ffffff',
    black: '#000000',
    green: '#218839',
  },
  red: {
    light: '#f0dcdc',
    main: '#CA0000',
  },
  grey: {
    lighter: '#e9e9ea',
    light: '#EFEFEF',
    main: '#BEBFC7',
    dark: '#5B666D',
    tableHeader: '#ececec',
    tableRow: '#f8f8f8',
    pregressBar: '#D9D9D9',
  },
  orange: {
    main: '#F68523',
    light: '#fde9d7',
  },
  green: {
    main: '#218839',
    light: '#daebde',
  },
  blue: {
    kingfisher: {
      main: '#51B4E1',
      light: '#edf7fc',
    },
    lightteal: {
      main: '#2D96A3',
      light: '#dcedf0',
    },
    trueblue: {
      main: '#2E4495',
      light: '#dce0ed',
    },
    banner: {
      main: '#e8f8ff',
    },
    link: {
      main: '#0054a4',
    },
  },
  purple: {
    main: '#800F8C',
    light: '#ead7ec',
  },
  silver: {
    main: '#F4F5F5',
  },
};
